let protocol = window.location.protocol + '//' + window.location.hostname + '/';
var url = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/';
//require('dotenv').load();
export const BASEURL = url;
export const IMGBASEURL = 'https://api.bewise.in/';
//export const IMGBASEURL = 'http://localhost:5005/';
export const USERURL = process.env.REACT_APP_USERURL;
export const RAZORPAY_LIVE = process.env.REACT_APP_RAZORPAY_LIVE;
export const RAZORPAY_TEST = process.env.REACT_APP_RAZORPAY_TEST;
export const GOOGLE_CAPTCHA_SITE_KEY = process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY;
export const GOOGLE_CAPTCHA_SECRET_KEY = process.env.REACT_APP_GOOGLE_CAPTCHA_SECRET_KEY;
export const REACT_APP_API_PATH = process.env.REACT_APP_API_PATH;
export const TINY_EDITOR = process.env.REACT_APP_TINY_EDITOR;
export const AZ_ASSET_PATH = process.env.REACT_APP_ASSET_PATH;

console.log("env", process.env);

export const MOBILE_REGEX = {
    message: 'The :attribute may be invalid.',
    rule: (val, params, validator) => {
        return validator.helpers.testRegex(val, /^[0-9\-,+\s]+$/);
    },
    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
    required: true  // optional
};
export const URL_REGEX = {  // name the rule
    message: 'The :attribute may be invalid.',
    rule: (val, params, validator) => {
        if (val)
            return validator.helpers.testRegex(val, /^[a-zA-Z_0-9\-.:,@/\s]+$/);
    },
    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
    required: true  // optional
};



export const CITIES = [
    {"id":27,"location":"Hosur","latitude":"12.7409","longitude":"77.8253","status":1,"sort_order":4},
    {"id":1,"location":"Bengaluru","latitude":"12.9716","longitude":"77.5946","status":1,"sort_order":1},
    {"id":12,"location":"Chennai","latitude":"13.0569","longitude":"80.2425","status":1,"sort_order":2},
    {"id":11,"location":"Coimbatore","latitude":"11.0168","longitude":"76.9558","status":1,"sort_order":3},
    {"id":2,"location":"Hyderabad","latitude":"17.3850","longitude":"78.4867","status":1,"sort_order":4},
    {"id":24,"location":"Madurai","latitude":"9.9252","longitude":"78.1198","status":1,"sort_order":5},
    {"id":13,"location":"Mumbai","latitude":"19.0760","longitude":"72.8777","status":1,"sort_order":7},
    {"id":15,"location":"Kolkata","latitude":"22.5726","longitude":"88.3639","status":1,"sort_order":8},
    {"id":16,"location":"New Delhi","latitude":"28.6139","longitude":"77.2090","status":1,"sort_order":9},
    {"id":17,"location":"Jaipur","latitude":"26.9124","longitude":"75.7873","status":1,"sort_order":10},
    {"id":18,"location":"Chandigarh","latitude":"30.7333","longitude":"76.7794","status":1,"sort_order":11},
    {"id":19,"location":"Pune","latitude":"18.5204","longitude":"73.8567","status":1,"sort_order":12},
    {"id":20,"location":"Kochi","latitude":"9.9312","longitude":"76.2673","status":1,"sort_order":13},
    {"id":21,"location":"Noida","latitude":"28.5355","longitude":"77.3910","status":1,"sort_order":14},
    {"id":22,"location":"Agra","latitude":"27.1767","longitude":"78.0081","status":1,"sort_order":15},
    {"id":23,"location":"Puducherry","latitude":"11.9416","longitude":"79.8083","status":1,"sort_order":16},
    {"id":25,"location":"Tiruchirappalli","latitude":"10.7905","longitude":"78.7047","status":1,"sort_order":17}
];


// WEBPACK FOOTER //
// ./src/constant.js